import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/icalSync/icalSyncQueryKeys.ts
var t = e("ical-sync", {
	feeds: (e) => ["feeds", e],
	unhealthyFeeds: (e) => ["unhealthyFeeds", e],
	feed: (e) => ["feed", e],
	token: (e) => ["token", e],
	feedBlocks: (e) => ["feedBlocks", e]
});
//#endregion
export { t as icalSyncQueryKeys };
